import * as React from "react"
import type { SVGProps } from "react"
const SvgPlug = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5 21.43a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-1a2 2 0 0 0-.64-.44.6.6 0 0 1-.36-.56v-3q0-.42.29-.71a1 1 0 0 1 .71-.29h1v-7q0-1.65 1.18-2.82Q7.35 3.43 9 3.43c1.65 0 2.04.39 2.83 1.17A4 4 0 0 1 13 7.43v10q0 .83.59 1.41.58.6 1.41.59.83 0 1.41-.59.6-.6.59-1.41v-7h-1a1 1 0 0 1-.71-.29 1 1 0 0 1-.29-.71v-3a.6.6 0 0 1 .36-.56q.37-.17.64-.44v-1q0-.42.29-.71a1 1 0 0 1 .71-.29h2q.42 0 .71.29.3.29.29.71v1q.27.27.64.44a.6.6 0 0 1 .36.56v3q0 .42-.29.71a1 1 0 0 1-.71.29h-1v7q0 1.65-1.17 2.83-1.18 1.17-2.83 1.17c-1.65 0-2.04-.4-2.82-1.17A4 4 0 0 1 11 17.42v-10q0-.82-.59-1.41A2 2 0 0 0 9 5.43q-.82 0-1.41.59A2 2 0 0 0 7 7.43v7h1q.42 0 .71.29.3.29.29.71v3a.6.6 0 0 1-.36.56 2 2 0 0 0-.64.44v1q0 .42-.29.71a1 1 0 0 1-.71.29z" />
  </svg>
)
export default SvgPlug
